import { defineStore } from 'pinia'
import { dailyStorage, sharedKeyPersist } from './persistence'

export const useUpsellStore = defineStore('upsell', {
	state: () => ({
		upsellRoutes: [],
		purchasedUpsells: {},
		glpShippingData: null,
	}),

	getters: {
		getNextUpsellRouteName: (state) => (currentRouteName, upgradeRouteName) => {
			const upgradeOrUpdateRouteName = upgradeRouteName || 'update-profile'

			if (state.upsellRoutes.length === 0) {
				return upgradeOrUpdateRouteName
			}

			const currentRouteIndex = state.upsellRoutes.indexOf(currentRouteName)

			if (currentRouteIndex === -1) {
				return state.upsellRoutes[0]
			} else if (currentRouteIndex < state.upsellRoutes.length - 1) {
				return state.upsellRoutes[currentRouteIndex + 1]
			}

			return upgradeOrUpdateRouteName
		},

		getGlpShippingData: (state) => state.glpShippingData,
	},

	actions: {
		setUpsellRoutes(order) {
			this.upsellRoutes = order
		},

		setPurchasedUpsell(purchasedUpsell) {
			this.purchasedUpsells[purchasedUpsell] = true
		},

		setGlpShippingData(data) {
			this.glpShippingData = data
		},
	},

	persist: sharedKeyPersist('onedaystorage', 'upsell', dailyStorage),
})
